import { ILogin } from '../interfaces/auth.interface';
import { HandlerResponse, postRequestNoToken } from './api';

export const loginAPI = async (payload: ILogin): Promise<any> => {
  return postRequestNoToken(`${process.env.REACT_APP_API_ENDPOINT}/sessions/login`, payload)
    .then((resp: any) => HandlerResponse(resp));
};
